/**
 * Typed page state and response mapping for the Inspections listing.
 *
 * Canonical source of truth for all InspectionsIndex adapter/hook/service files.
 * Shared listing primitives come from @hooks/listings — only inspection-specific
 * types are defined here.
 */
// ---------------------------------------------------------------------------
// Initial / default filter values
// ---------------------------------------------------------------------------
export const INITIAL_INSPECTION_FILTERS = {
    scheduledDate: { start: null, end: null, rangeType: null },
    inspectionDate: { start: null, end: null, rangeType: null },
    dueDate: { start: null, end: null, rangeType: null },
    visitDate: { start: null, end: null, rangeType: null },
    frequency: [],
    building: [],
    status: [],
    technician: [],
    asset: [],
    technicianTeam: [],
    account: [],
    territory: [],
    additionalTerritory: [],
    tags: [],
    buildingTags: [],
    accountTags: [],
    workOrderTags: [],
    subcontractor: [],
    inspectionType: [],
    buildingStatus: null,
    noAccess: null,
    zipCode: '',
    referenceNumber: '',
    workOrder: '',
    inspectionId: '',
    tce: false,
    tceErrors: false,
    irol: false,
    irolErrors: false,
    livsafe: false,
    livsafeErrors: false,
    inspectionSeries: null
};
/**
 * Filter keys that are active (visible) by default.
 * Mirrors INITIAL_FILTERS.active in constants.js.
 */
export const DEFAULT_ACTIVE_FILTER_KEYS = [
    'building',
    'technician',
    'status',
    'frequency',
    'asset',
    'scheduledDate'
];
